import React from 'react';
import '../style/applicationPolicy.css'
import AdvancedDisbursementsFormHOC from "../containers/AdvancedDisbursements/advancedDisbursementsFormHOC";
import ChangeApplicationStatusModal from "./ApplicationPolicy/changeApplicationStatusModal";
import TransferApplicationBetweenSolicitorUsersModal from "./ApplicationPolicy/transferApplicationBetweenSolicitorUsersModal";
import ApplyPigConfirmationModal from "./ApplicationPolicy/applyPigConfirmationModal";
import PolicyTabs from "./ApplicationPolicy/policyTabs";
import ApplicationPolicyPageContent from "./ApplicationPolicy/applicationPolicyPageContent";
import {ApplicationPolicyViewHeader} from "./ApplicationPolicy/applicationPolicyViewHeader";
import '../style/mediaPrint.css'
import ApplicationPremiumSettingsHOC from '../containers/ApplicationPremiumSettings/applicationPremiumSettingsHOC';
import {NOT_FOUND_MESSAGE, POLICY_NOT_READY_FOR_CLAIMS_MESSAGE, TRANSFER_NOT_REFLECTED_MESSAGE} from "../helpers/variables";
import CostsSummary from './ApplicationPolicy/costsSummary';
import { Alert, FormGroup, Heading, HorizontalRule, Loader } from 'arag-ui-lib';
import {DOTS, ERROR, HEADING_2, MEDIUM, SIZE_LG, POLICY_STATUS_MN_REFERRED, INFO, WARNING} from "../helpers/constants";
import ModalWrapper from '../helpers/modalWrapper';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';

const ApplicationPolicy = (props) => {
	const {
		UpdateTab,
		costsSummaryModal,
		toggleCostsSummaryModal,
		SelectedApp,
		newApplication,
		User,
		Store,
		_closeAdvancedDisbursementsApplicationModal,
		handleCheck,
		cancelEditOfApplicationPremium,
		isEditingApplicationPremium,
		editApplicationPremium,
		TransferApplicationBetweenSolicitorUsers,
		internalAlertsModalOpen,
		internalAlerts,
		toggleInternalAlertModal,
		handleSolicitorFirmSelect,
		handleSolicitorSelect,
		// ChangeApplicationStatusModal
		_updatePolicyStatus,
		badResponseAppPsMessage,
		// TransferApplicationBetweenSolicitorUsersModal
		SolicitorFirms,
		AgentsList,
		_transferApplication,
		// PolicyTabs
		SelectActiveTab,
		// ApplicationPolicyPageContent
		SavedApplicationAttachments,
		openFilePreview,
		requestApplicationAttachment,
		RequestDeleteDocument,
		openRenameAttachmentModal,
		closeRenameAttachmentModal,
		requestRenameAttachment,
		CheckUserOverviewTabCheckBox,
		PageShift,
		ChangeOverViewTabReadMoreState,
		_openAdvancedDisbursementsApplicationModal,
		match,
		router,
		isArag,
		isSolicitor,
		isChangeStatusModalOpen,
		statusOptions,
		advanceDisbursementsEnabled,
		setEditingStaged,
		editingStaged,
		closePremiumSettingsModal,
		handleOpenStatusModal,
		handleCloseStatusModal,
		handleCloseTransferModal,
		handleClearStatus,
		handleDismissCostsSummaryError,
		handleStatusChange,
		handleFieldChange,
		handleMarkAsViewed,
		handleTransferCase,
		handleCloseApplyPigModal,
		_applyPig,
	} = props;

	if (newApplication.fetchingSelectedApp) {
		return (
			<div className={"col-sm-12 col-sm-offset-5"}>
				<Loader variant={DOTS} dotSize={MEDIUM} />
			</div>
		);
	}
	if (!SelectedApp.id) {
		return (
			<div className={'row'}>
				<div className={"col-sm-12"}><Alert variant={ERROR} label={NOT_FOUND_MESSAGE} /></div>
			</div>
		);
	}

	return (
		<div className="row print">
			{
				(isArag && SelectedApp.systemsOfRecordName && !SelectedApp.importedDate)
				?
					<div className={"col-sm-12"}>
						<Alert
							variant={WARNING}
							label={POLICY_NOT_READY_FOR_CLAIMS_MESSAGE}
						/>
					</div>
				:
					null
			}
			{
				(isArag && !Store.isPolicyLawsysFirmBankAccountValid)
				?
					<div className={"col-sm-12"}>
						<Alert variant={Store.checkLawsysFirmBankAccountValidityErrorMessageBoxStyle} label={Store.checkLawsysFirmBankAccountValidityErrorMessage} />
					</div>
				:
					null
			}
			{
				Store.badResponsePatchNotification
				?
					<div className={"col-sm-12"}>
						<Alert variant={ERROR} label={Store.badResponsePatchNotification} />
					</div>
				:
					null
			}
			{
				/* US 101077: gATEway and the claim record disagree about the owning firm. Persisted on the
				   policy, so it shows on every visit until a later transfer is accepted - not dismissible.
				   The Store copy covers the moments after a transfer, before the policy is re-fetched.
				   ARAG only, like the two banners above: transferring is an ARAG-only action, so a
				   solicitor could neither have caused this nor do anything about it. */
				(isArag
					&& (SelectedApp.budTransferSucceeded === false
						|| (Store.transferError && Store.transferErrorApplicationId === SelectedApp.id)))
				?
					<div className={"col-sm-12"}>
						<Alert
							variant={ERROR}
							label={Store.transferError || TRANSFER_NOT_REFLECTED_MESSAGE}
						/>
					</div>
				:
					null
			}
			{
				(!!UpdateTab.costsSummaryError && UpdateTab.costsSummaryError.length > 0)
				?
					<div className={"col-sm-12"}>
						<Alert
							variant={ERROR}
							label={UpdateTab.costsSummaryError}
							onDismiss={handleDismissCostsSummaryError}
						/>
					</div>
				:
					null
			}
			<ModalWrapper
				isOpen={Store.advancedDisbursementsApplicationModalOpen}
				onClose={_closeAdvancedDisbursementsApplicationModal}
				modalTestId={''}
				buttonTestId={''}
			>
				<AdvancedDisbursementsFormHOC applicationId={SelectedApp.id} cancel={_closeAdvancedDisbursementsApplicationModal} />
			</ModalWrapper>

			<CostsSummary
				costsSummary={UpdateTab.costsSummary}
				costsSummaryModal={costsSummaryModal}
				toggleCostsSummaryModal={toggleCostsSummaryModal}
				selectedApp={SelectedApp}
				advanceDisbursementsEnabled={advanceDisbursementsEnabled}
			/>

			<div className={"col-sm-12"}>
				<ModalWrapper
					isOpen={isChangeStatusModalOpen}
					onClose={handleCloseStatusModal}
					modalTestId={'change-status-modal'}
					buttonTestId={'change-status-close'}
				>
					<form className="form-horizontal">
						<FormGroup
							variant={FORM_GROUP_VARIANTS.SELECT}
							label={CONTENT_STRINGS.CHANGE_STATUS_TO}
							labelSize="col-sm-3"
							inputSize="col-sm-5"
							inputProps={{
								name: "selectedStatus",
								value: Store.selectedStatusMachineName,
								onChange: handleStatusChange,
								options: statusOptions,
							}}
							formGroupTestId={'change-status-to-form-group'}
						/>
					</form>
				</ModalWrapper>
				<ModalWrapper
					isOpen={Store.selectedStatusMachineName !== '' && !Store.openPremiumSettingsModal}
					onClose={handleClearStatus}
					modalTestId={'change-status-confirmation-modal'}
					buttonTestId={'change-status-confirmation-close'}
				>
					<ChangeApplicationStatusModal
						Store={Store}
						newApplication={newApplication}
						handleCheck={handleCheck}
						handleFieldChange={handleFieldChange}
						_updatePolicyStatus={_updatePolicyStatus}
						badResponseAppPsMessage={badResponseAppPsMessage}
						handleClearStatus={handleClearStatus}
					/>
				</ModalWrapper>
				<ModalWrapper
					isOpen={Store.openPremiumSettingsModal}
					size={SIZE_LG}
					onClose={closePremiumSettingsModal}
					modalTestId={''}
					buttonTestId={''}
				>
					<ApplicationPremiumSettingsHOC
						isChangingStatusOfApp={true}
						showTable={!isEditingApplicationPremium}
						isEditMode={isEditingApplicationPremium}
						isApplicationPremium={true}
						applicationPremiumCancelHandler={isEditingApplicationPremium ? cancelEditOfApplicationPremium : null}
						selectedApplicationCaseTypeId={SelectedApp.caseTypeId}
						onApplicationPremiumEdit={isEditingApplicationPremium ? null : editApplicationPremium}
						onCancel={closePremiumSettingsModal}
						isEditStaged={editingStaged}
						onEditStaged={setEditingStaged}
					/>
				</ModalWrapper>
				<ModalWrapper
					isOpen={Store.openTransferApplicationModal}
					onClose={handleCloseTransferModal}
					title={CONTENT_STRINGS.TRANSFER_CASE}
					modalTestId={'transfer-case-modal'}
					buttonTestId={'transfer-case-close'}
				>
					<TransferApplicationBetweenSolicitorUsersModal
						SelectedApp={SelectedApp}
						Store={Store}
						SolicitorFirms={SolicitorFirms}
						AgentsList={AgentsList}
						handleSolicitorFirmSelect={handleSolicitorFirmSelect}
						handleSolicitorSelect={handleSolicitorSelect}
						_transferApplication={_transferApplication}
						TransferApplicationBetweenSolicitorUsers={TransferApplicationBetweenSolicitorUsers}
					/>
				</ModalWrapper>
				<ModalWrapper
					isOpen={Store.openApplyPigModal}
					onClose={handleCloseApplyPigModal}
					title={CONTENT_STRINGS.APPLY_PREMIUM_INDEMNITY_GUARANTEE}
					modalTestId={'apply-pig-modal'}
					buttonTestId={'apply-pig-close'}
				>
					<ApplyPigConfirmationModal
						applyingPig={Store.applyingPig}
						_applyPig={_applyPig}
						handleCloseApplyPigModal={handleCloseApplyPigModal}
						badResponseApplyPig={Store.badResponseApplyPig}
					/>
				</ModalWrapper>
				<div className="row">
					<div className={"col-sm-12"}>
						<Heading
							variant={HEADING_2}
							title={CONTENT_STRINGS.APPLICATION_POLICY}
							headingTestId={"application-policy-header"}
						/>
					</div>
					<ApplicationPolicyViewHeader
						UpdateTab={UpdateTab}
						internalAlertsModalOpen={internalAlertsModalOpen}
						internalAlerts={internalAlerts}
						toggleInternalAlertModal={toggleInternalAlertModal}
						User={User}
						SelectedApp={SelectedApp}
						Store={Store}
						toggleCostsSummaryModal={toggleCostsSummaryModal}
						handleOpenStatusModal={handleOpenStatusModal}
						handleMarkAsViewed={handleMarkAsViewed}
						handleTransferCase={handleTransferCase}
					/>
				</div>
				<div className="row">
					<div className={"col-sm-12"}>
						<HorizontalRule />
					</div>
				</div>
				<PolicyTabs
					Store={Store}
					SelectedApp={SelectedApp}
					User={User}
					SelectActiveTab={SelectActiveTab}
					isArag={isArag}
					isSolicitor={isSolicitor}
					advanceDisbursementsEnabled={advanceDisbursementsEnabled}
				/>
				<ApplicationPolicyPageContent
					Store={Store}
					User={User}
					SelectedApp={SelectedApp}
					newApplication={newApplication}
					SavedApplicationAttachments={SavedApplicationAttachments}
					openFilePreview={openFilePreview}
					requestApplicationAttachment={requestApplicationAttachment}
					RequestDeleteDocument={RequestDeleteDocument}
					openRenameAttachmentModal={openRenameAttachmentModal}
					closeRenameAttachmentModal={closeRenameAttachmentModal}
					requestRenameAttachment={requestRenameAttachment}
					CheckUserOverviewTabCheckBox={CheckUserOverviewTabCheckBox}
					PageShift={PageShift}
					ChangeOverViewTabReadMoreState={ChangeOverViewTabReadMoreState}
					_openAdvancedDisbursementsApplicationModal={_openAdvancedDisbursementsApplicationModal}
					match={match}
					router={router}
					isArag={isArag}
					advanceDisbursementsEnabled={advanceDisbursementsEnabled}
				/>
			</div>
		</div>
	);
};

export default ApplicationPolicy;
